(function () {
  /////// Display breadcrumbs shadow relative to scroll bar position
  const scrollBreadcrumbs = document.querySelector('.breadcrumbs__list');

  if (scrollBreadcrumbs) {
    const breadcrumbs = document.querySelector('.breadcrumbs');
    const maxScrollLeft =
      scrollBreadcrumbs.scrollWidth - scrollBreadcrumbs.clientWidth;

    function breadcrumbsShadow() {
      if (scrollBreadcrumbs.scrollLeft === maxScrollLeft) {
        breadcrumbs.classList.add('breadcrumbs__align-right');
      } else if (scrollBreadcrumbs.scrollLeft === 0) {
        breadcrumbs.classList.add('breadcrumbs__align-left');
      } else {
        breadcrumbs.classList.remove('breadcrumbs__align-right');
        breadcrumbs.classList.remove('breadcrumbs__align-left');
      }
    }
    scrollBreadcrumbs.addEventListener('scroll', () => {
      breadcrumbsShadow();
    });
  }

  /////// Share button
  const shareBtn = document.querySelector('.breadcrumbs-share-btn');

  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      const url = shareBtn.dataset.shareUrl;
      const title = shareBtn.dataset.shareTitle;

      if (navigator.share) {
        await navigator.share({ title, url });
      } else {
        await navigator.clipboard.writeText(url);
        shareBtn.classList.add('is-copied');
        setTimeout(() => shareBtn.classList.remove('is-copied'), 2000);
      }
    });
  }
})(jQuery);
